export const RequiredAsterisk = () => <span className="text-red-600">*</span>;
